import { render } from "./NumberBox.vue?vue&type=template&id=43221a5f&scoped=true"
import script from "./NumberBox.vue?vue&type=script&lang=js"
export * from "./NumberBox.vue?vue&type=script&lang=js"

import "./NumberBox.vue?vue&type=style&index=0&id=43221a5f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43221a5f"]])

export default __exports__